import { getDocumentAsync } from 'expo-document-picker';
import { Platform } from 'react-native';

export const documentPicker = async () => {
  const result = await getDocumentAsync({
    type: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'image/*',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ],
    multiple: true,
    copyToCacheDirectory: true,
  });
  if (result.canceled) return [];
  return result.assets.map(asset => Platform.OS === 'web'
    ? asset.file
    : { ...asset, type: asset.mimeType });
};